var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildingVerification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35235",
    "data-name": "Group 35235",
    transform: "translate(-757.7 -295)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9815",
    "data-name": "Rectangle 9815",
    width: 40,
    height: 40,
    transform: "translate(757.7 295)",
    fill: "red",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35290",
    "data-name": "Group 35290",
    transform: "translate(763.534 298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72305",
    "data-name": "Path 72305",
    d: "M76.333,16.444h6.3",
    transform: "translate(-68.967 8.111)",
    fill: "none",
    stroke: "#f49c43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72306",
    "data-name": "Path 72306",
    d: "M76.333,12.5H86.407",
    transform: "translate(-68.967 5.35)",
    fill: "none",
    stroke: "#f49c43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72307",
    "data-name": "Path 72307",
    d: "M89.438,2H78.221A5.162,5.162,0,0,0,73,7.1V30.9A5.162,5.162,0,0,0,78.221,36h4.448M89.438,2l10.636,10.625M89.438,2v8.925a1.721,1.721,0,0,0,1.74,1.7h8.9m0,0v7.91",
    transform: "translate(-73 -2)",
    fill: "none",
    stroke: "#f49c43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72308",
    "data-name": "Path 72308",
    d: "M81.889,20.222l2.518,2.518,6.3-6.3",
    transform: "translate(-62.371 11.259)",
    fill: "none",
    stroke: "#f49c43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingVerification);
export default __webpack_public_path__ + "static/media/building-verification.6850344d62df63e2c9799cc404fb4002.svg";
export { ForwardRef as ReactComponent };